export const FUNDS_APP_URL = "/funds";
export const FUNDS_DEPOSIT_WITH_BANK_TRANSFER_URL =
  "/deposit-with-bank-transfer";


export const FUNDS_STAKING_FORM = 'staking';
export const FUNDS_TIMELOCK_STAKING_FORM = 'timelockStaking';
export const FUNDS_UNSTAKING_FORM = 'unstaking';
export const FUNDS_PENDING_STAKED_ETH = 'pendingStakedEth';
export const FUNDS_BUY_FORM = 'manage/buy';
export const FUNDS_SELL_FORM = 'manage/sell';
export const FUNDS_DEPOSIT_FORM = 'manage/deposit';
export const FUNDS_WITHDRAW_FORM = 'manage/withdraw';